/* eslint-disable @typescript-eslint/no-unused-vars */
import { ThinEngine } from "../../Engines/thinEngine.js";
ThinEngine.prototype._debugPushGroup = function (groupName, targetObject) { };
ThinEngine.prototype._debugPopGroup = function (targetObject) { };
ThinEngine.prototype._debugInsertMarker = function (text, targetObject) { };
ThinEngine.prototype._debugFlushPendingCommands = function () { };
//# sourceMappingURL=engine.debugging.js.map